// extracted by mini-css-extract-plugin
export default {"playerFromEpg":"styles_playerFromEpg__+4emM","containerPlayer":"styles_containerPlayer__XrqyD"};